/* Fix: lockScroll() sets body{position:fixed; top:-scrollY}, which breaks the
  sticky header and drags the cart/nav drawer off-screen.
  Zeroing the offset restores header + drawer to their sticky position. */
(function () {
  var lastScroll = 0, ticking = false;
  function refresh() { document.dispatchEvent(new CustomEvent('size:drawer')); }

  window.addEventListener('scroll', function () {
    if (!document.querySelector('.site-header__drawer.is-active')) lastScroll = window.pageYOffset;
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(function () { ticking = false; refresh(); });
    }
  }, { passive: true });

  window.addEventListener('resize', refresh);
  if (window.visualViewport) window.visualViewport.addEventListener('resize', refresh);

  ['cart:open', 'mobileNav:open'].forEach(function (evt) {
    document.addEventListener(evt, function () {
      document.body.classList.add('has-slide-modal-open');
      requestAnimationFrame(refresh);          // catch the focus-scroll
    });
  });

  document.addEventListener('headerDrawer:closed', function () {   // ← not cart:close
    document.body.classList.remove('has-slide-modal-open');
  });
})();